import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '40px 40px 24px'
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px'
  },
  cardWrapper: {
    margin: '0 40px'
  },
  filterAddButton: {
    width: 'fit-content',
    background: '#9F9E9E',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #70707033',
    borderRadius: '4px',
    opacity: '50%'
  },
  filterWrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: '20px',
    borderBottom: '1px solid #70707033'
  },
  filterLabel: {
    color: '#6B7073',
    fontSize: '12px',
    margin: '0 20px'
  },
  tableWrapper: {
    padding: '20px'
  },
  disclaimer: {
    color: '#4A4A4A',
    fontSize: '14px',
    marginTop: '30px'
  },
  container: {
    padding: '30px 35px',
  },
  wrapper: {
    display: 'flex',
    minHeight: '450px',

    '& .MuiAutocomplete-root': {
      width: '40%',

      '& .MuiTextField-root': {
        width: '100%'
      }
    }
  },
  formWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '80%'
  },
  formContainer: {
    width: '100%'
  },
  groupContainer: {
    width: '20%',
    borderLeft: '1px solid #D8DCDE',
    padding: '0px 36px'
  },
  field: {
    marginTop: '24px'
  },
  input: {
    fontSize: '14px',
    color: '#545455',
    width: '40%',
    '@media (min-width: 3000px)': {
      '& svg': {
        top: 'calc(50% - 25px)'
      }
    }
  },
  underline: {
    '&::before': {
      borderColor: 'rgba(0, 0, 0, 0.42)'
    }
  },
  hr: {
    border: 'none',
    borderTop: '1px solid #D8DCDE'
  },
  shrink: {
    color: '#6F6F8C',
    fontSize: '12px'
  },
  button: {
    textTransform: 'capitalize',
    fontSize: '17px',
    marginRight: 0
  },
  groupingWrapper: {
    marginTop: '42px',
  },
  groupingLabel: {
    color: '#6F6F6F',
    opacity: 0.8,
    fontSize: '14px'
  },
  fieldArrayWrapper: {
    background: '#7070700F',
    padding: '20px',
    margin: '14px 0',
    width: '80%'
  },
  fieldRow: {
    display: 'flex',
    alignItems: 'flex-end',
    color: '#545455',
    justifyContent: 'space-between',

    '& .MuiTextField-root': {
      width: '40%'
    }
  },
  icon: {
    color: '#545455'
  },
  fieldInput: {
    fontSize: '14px',
    color: '#545455',

    '@media (min-width: 3000px)': {
      '& svg': {
        top: 'calc(50% - 25px)'
      }
    }
  },
  hide: {
    visibility: 'hidden'
  },
  options: {
    background: '#fff !important',
    padding: '0px 12px !important'
  },
  autocompleteOptions: {
    color: '#6F6F6F',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  checkbox: {
    color: '#F37320',
    padding: 0
  },
  tagWrapper: {
    display: 'flex',
    color: '#545455',
    fontSize: '14px'
  },
  paper: {
    maxHeight: '200px',
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: '5px'
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#c3c3c3',
      width: '5px'
    }
  },
  dropdownStyle: {
    maxHeight: '200px',
    backgroundColor: `${theme.palette.primary.cards} !important`,

    '&::-webkit-scrollbar': {
      width: '3px'
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#c3c3c3',
      width: '5px'
    }
  },
  disable: {
    opacity: '50%',
    pointerEvents: 'none'
  },
  note: {
    color: '#6F6F6F',
    fontSize: '12px',
    opacity: 0.6,
    marginTop: '4px'
  },
  popWrapper: {
    padding: '40px',
    textAlign: 'center'
  },
  popText: {
    color: '#565657',
    fontSize: '20px',
    fontWeight: 'bold'
  },
  ackButton: {
    margin: '5px auto',
    width: '40%',
    height: '36px'
  },
  allSystems: {
    color: '#4A4A4A',
    fontWeight: 'bold',

    '& button': {
      color: '#4A4A4A !important',
      fontWeight: 'bold',
      pointerEvents: 'none'
    }
  },
  tableHeading: {
    verticalAlign: 'baseline',
    '& span': {
      fontSize: '14px'
    },
    '& button': {
      alignItems: 'end'
    }
  },
  totSystems: {
    width: '150px',
  },
  batteryCapacity: {
    width: '210px',
  },
  tableRightAlign: {
    textAlign: 'right',
    '& p': {
      marginRight: '20px'
    }
  },
  tabelLastCol: {
    '& p': {
      width: '150px',
      textAlign: 'right'
    }
  },
  vppName: {
    width: '200px',

    '& button': {
      marginLeft: '20px'
    }
  },
  programName: {
    width: '200px',
  },
  buttonGroup: {
    width: '70%',
    margin: '20px auto 0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  stateDropDown: {
    padding: '10px 0',

    '& .MuiAutocomplete-listbox': {
      maxHeight: '200px'
    }
  },
  error: {
    color: 'red',
    fontSize: '12px',
    marginTop: '10px',
    whiteSpace: 'pre-wrap'
  },
  inputMultiSelect: {
    '@media (min-width: 3000px)': {
      '& .MuiAutocomplete-endAdornment': {
        top: 'calc(50% - 25px)'
      }
    }
  },
  buttonWrapper: {
    display: 'flex', 
    justifyContent: 'space-between'
  }
}))

export { useStyles }